import httpAdmin from '@/httpCommon/axiosClient';

class ReportService {
    getReport = async (params: any) => {
        const res = await httpAdmin.get('report/daily', { params });
        return res?.data;
    };
}
export default new ReportService();
